import PropTypes from 'prop-types';

export const formatDate = (dateStr) => {
  if (!dateStr) return null;

  const [year, month, day] = dateStr.split('-');
  if (!year || !month || !day) return null;

  return `${day.padStart(2, '0')}/${month.padStart(2, '0')}/${year}`;
};

export default function DateDisplay({
  value,
  placeholder = 'Não informado',
  readOnly = true,
  ...rest
}) {
  const formatted = formatDate(value);

  return (
    <input
      type="text"
      value={formatted ?? placeholder}
      readOnly={readOnly}
      {...rest}
    />
  );
}

DateDisplay.propTypes = {
  value: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
};

